import { render, staticRenderFns } from "./AddCompanyRankCard.vue?vue&type=template&id=3546200c&scoped=true&"
import script from "./AddCompanyRankCard.vue?vue&type=script&lang=js&"
export * from "./AddCompanyRankCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3546200c",
  null
  
)

export default component.exports